<template>
  <div class="driver-page">
    <div class="driver-card">
      <el-form :inline="true" :model="query" class="driver-query" @submit.native.prevent>
        <el-form-item label="司机姓名"><el-input v-model.trim="query.driverName" clearable placeholder="请输入司机姓名" @keyup.enter.native="search" /></el-form-item>
        <el-form-item label="手机号"><el-input v-model.trim="query.phone" clearable placeholder="请输入手机号" @keyup.enter.native="search" /></el-form-item>
        <el-form-item label="资料状态"><el-select v-model="query.enabled" clearable placeholder="全部" @change="search"><el-option label="全部" value="" /><el-option label="正常" :value="1" /><el-option label="禁用" :value="0" /></el-select></el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
          <el-button icon="el-icon-refresh-left" @click="reset">重置</el-button>
        </el-form-item>
      </el-form>
      <div class="driver-toolbar">
        <div>
          <el-button v-permission="'driver:add'" type="primary" icon="el-icon-plus" @click="openCreate">新增司机</el-button>
          <el-button v-permission="'driver:export'" icon="el-icon-download" :loading="exporting" @click="downloadDrivers">导出</el-button>
        </div>
        <el-tooltip content="刷新" placement="top"><el-button icon="el-icon-refresh" @click="fetchList" /></el-tooltip>
      </div>
      <el-table v-loading="loading" :data="list" border stripe>
        <el-table-column prop="driverNo" label="司机编号" width="110" align="center" />
        <el-table-column prop="driverName" label="司机姓名" min-width="160" align="center" show-overflow-tooltip />
        <el-table-column prop="phone" label="手机号" min-width="150" align="center" />
        <el-table-column label="创建时间" width="170" align="center"><template slot-scope="{ row }">{{ row.createTime | fmt }}</template></el-table-column>
        <el-table-column label="资料状态" width="100" align="center"><template slot-scope="{ row }"><el-tag :type="Number(row.enabled) === 1 ? 'success' : 'info'" size="small">{{ Number(row.enabled) === 1 ? '正常' : '禁用' }}</el-tag></template></el-table-column>
        <el-table-column label="操作" width="200" align="center" fixed="right">
          <template slot-scope="{ row }">
            <el-button v-permission="'driver:edit'" type="text" size="small" @click="openEdit(row)">编辑</el-button>
            <el-button v-permission="'driver:edit'" type="text" size="small" @click="changeStatus(row)">{{ Number(row.enabled) === 1 ? '禁用' : '启用' }}</el-button>
            <el-button v-permission="'driver:delete'" type="text" size="small" class="driver-delete" @click="remove(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination class="driver-pagination" background layout="total, prev, pager, next, sizes" :current-page="page" :page-size="limit" :page-sizes="[10, 20, 50, 100]" :total="total" @current-change="onPageChange" @size-change="onSizeChange" />
    </div>
    <driver-form-drawer :visible.sync="drawerVisible" :driver="currentDriver" @saved="onSaved" />
  </div>
</template>

<script>
import dayjs from 'dayjs'
import { deleteDriver, getDriverPage, exportDrivers, updateDriverStatus, isRequestSuccess } from './lingdongApi'
import { downloadWaybillBlob } from './waybillDownload'
import DriverFormDrawer from './DriverFormDrawer.vue'

const initialQuery = () => ({ driverName: '', phone: '', enabled: 1 })

export default {
  name: 'DriverManage',
  components: { DriverFormDrawer },
  filters: { fmt(value) { return value ? dayjs(value).format('YYYY-MM-DD HH:mm:ss') : '-' } },
  data() {
    return { loading: false, exporting: false, requestId: 0, list: [], total: 0, page: 1, limit: 20, query: initialQuery(), drawerVisible: false, currentDriver: null }
  },
  created() { this.fetchList() },
  beforeDestroy() { this.requestId += 1 },
  methods: {
    queryParams() {
      const params = { driverName: this.query.driverName, phone: this.query.phone }
      if (this.query.enabled !== '' && this.query.enabled !== null && this.query.enabled !== undefined) params.enabled = this.query.enabled
      return params
    },
    async fetchList() {
      const requestId = ++this.requestId
      this.loading = true
      try {
        const res = await getDriverPage({ ...this.queryParams(), page: this.page, limit: this.limit })
        if (requestId !== this.requestId) return
        if (!isRequestSuccess(res)) throw new Error(res.msg || '查询失败')
        this.list = (res.data && res.data.items) || []
        this.total = Number(res.data && res.data.total) || 0
        const maxPage = Math.max(1, Math.ceil(this.total / this.limit))
        if (this.page > maxPage) { this.page = maxPage; return this.fetchList() }
      } catch (e) {
        if (requestId !== this.requestId) return
        this.list = []
        this.total = 0
        this.$message.error(e.msg || e.message || '查询失败')
      } finally {
        if (requestId === this.requestId) this.loading = false
      }
    },
    search() { this.page = 1; this.fetchList() },
    reset() { this.query = initialQuery(); this.search() },
    onPageChange(page) { this.page = page; this.fetchList() },
    onSizeChange(limit) { this.limit = limit; this.page = 1; this.fetchList() },
    async downloadDrivers() {
      if (this.exporting) return
      this.exporting = true
      try {
        const response = await exportDrivers(this.queryParams())
        await downloadWaybillBlob(response, `司机导出_${dayjs().format('YYYYMMDDHHmmss')}.xlsx`)
        this.$message.success('导出成功')
      } catch (e) {
        this.$message.error(e.msg || e.message || '导出失败')
      } finally { this.exporting = false }
    },
    async changeStatus(row) {
      const enabled = Number(row.enabled) === 1 ? 0 : 1
      const action = enabled === 1 ? '启用' : '禁用'
      try {
        await this.$confirm(`确认${action}司机“${row.driverName}”吗？`, '提示', { type: 'warning' })
        const res = await updateDriverStatus(row.id, enabled)
        if (!isRequestSuccess(res)) throw new Error(res.msg || `${action}失败`)
        this.$message.success(`司机已${action}`)
        this.fetchList()
      } catch (e) {
        if (e && e !== 'cancel' && e !== 'close') this.$message.error(e.msg || e.message || `${action}失败`)
      }
    },
    openCreate() { this.currentDriver = null; this.drawerVisible = true },
    openEdit(row) { this.currentDriver = row; this.drawerVisible = true },
    onSaved() { this.fetchList() },
    remove(row) {
      this.$confirm(`确认删除司机“${row.driverName}”吗？`, '提示', { type: 'warning' }).then(async () => {
        const res = await deleteDriver(row.id)
        if (!isRequestSuccess(res)) throw new Error(res.msg || '删除失败')
        this.$message.success('司机已删除')
        this.fetchList()
      }).catch((e) => {
        if (e && e !== 'cancel' && e !== 'close') this.$message.error(e.msg || e.message || '删除失败')
      })
    }
  }
}
</script>

<style scoped>
.driver-page { width: 100%; min-height: 100%; padding: 16px; box-sizing: border-box; background: #f0f2f5; }
.driver-card { min-height: 100%; padding: 16px; border-radius: 4px; background: #fff; box-sizing: border-box; }
.driver-query { margin-bottom: 4px; }
.driver-toolbar { display: flex; align-items: center; justify-content: space-between; margin-bottom: 12px; }
.driver-delete { color: #e64545; }
.driver-pagination { margin-top: 16px; text-align: right; }
</style>
